//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Features.js";
let d=[[[0,"BendLocation",1,0],[0,"BendOptions",0,"Features.SheetMetal.BendOptions",0],[0,"Direction",1,0],[0,"ExtendProfile",1,0],[0,"FixedSide",1,0],[0,"Section",1,"Section",0],[0,"Sketch",1,"Features.SketchFeature",0],[0,"TargetFace",1,"Face",0]],[[[],"GetBendAngle",{R_:{bend_angle:"Expression"}},0,0],[["bend_angle"],"SetBendAngle",{},1,0],[[],"ValidateBuilderData",{R_:{builder_data_validity:''}},0,0]],[]];
SPLM.Features.SheetMetal.BendBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.BendBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.BendBuilder.BendDirectionOptions = Object.freeze({
    "SectionNormalSide" : "SectionNormalSide", "SectionReverseNormalSide" : "SectionReverseNormalSide"});

SPLM.Features.SheetMetal.BendBuilder.FixedSideOptions = Object.freeze({
    "SectionSideLeft" : "SectionSideLeft", "SectionSideRight" : "SectionSideRight"});

SPLM.Features.SheetMetal.BendBuilder.BendLocationOptions = Object.freeze({
    "OuterMoldLine" : "OuterMoldLine", "CenterLine" : "CenterLine", "InnerMoldLine" : "InnerMoldLine", "MaterialInside" : "MaterialInside", "MaterialOutside" : "MaterialOutside"});

export default SPLM;